<template>
    <div>
        <CoeFilter
            style="margin-bottom: 20px"
            @status-changed="handleOnStatusChanged"
            :selected-dates="selectedDates"
            @date-change="handleDateChange"
        />
        <CoeList
            :user-type="userType"
            :requests-data-list="coeList"
            :is-loading="isLoading"
            :total-count="totalCount"
            :current-page="currentPage"
            :total-per-page="limit"
            :limit="limit"
            @reload="handleReload"
            @view="handleView"
            @on-page-change="handleOnPageChanged"
        />

        <CreateCoeModal ref="CreateRequest" @create="loadData" />
    </div>
</template>
<script>
import CreateCoeModal from '@/components/Requests/Dev/COE/CreateCoeModal.vue';
import CoeFilter from '@/components/Requests/Dev/COE/CoEFilter.vue';
import CoeList from '@/components/Requests/Dev/COE/CoeList.vue';
import { getPaginatedCoeAdmin } from '@/services/coe.services';
import { endOfDate, startOfDate } from '../../../../../utility/helper';

export default {
    components: { CoeFilter, CoeList, CreateCoeModal },
    // eslint-disable-next-line vue/require-default-prop
    props: { userType: { type: String } },
    data() {
        return {
            coeList: [],
            currentPage: 1,
            totalCount: 1,
            filter: {},
            limit: 10,
        };
    },
    async mounted() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            const { data } = await getPaginatedCoeAdmin({
                filter: this.filter,
                page: this.currentPage,
                limit: this.limit,
            });
            this.coeList = data.data;
            this.totalCount = data.totalCount;
        },
        handleView(coe) {
            this.$refs.CreateRequest.openModalForAdmin(coe._id);
        },
        openCoeModal() {
            this.$refs.CreateRequest.openModal();
        },
        handleOnStatusChanged(data) {
            this.filter = { ...this.filter, status: data };
            this.loadData();
        },
        handleDateChange(data) {
            delete this.filter['createdAt'];
            this.filter = {
                ...this.filter,
                ...(data.from && { createdAt: { $gte: startOfDate(data.from), $lte: endOfDate(data.to) } }),
            };
            this.loadData();
        },
        handleOnPageChanged(page) {
            this.currentPage = page;
            this.loadData();
        },
    },
};
</script>
